import React from 'react';
import { Link } from 'react-router-dom';
import { FiFileText, FiUser, FiArrowRight } from 'react-icons/fi';
import './AiStudio.css';

const TOOLS = [
  {
    to: '/resumes',
    title: 'Resume Builder',
    description:
      'Fill a resume form, score it for a role, and get section-by-section fixes. Contact details stay on the form and are not sent for review.',
    icon: FiFileText,
    tone: 'purple',
    cta: 'Open Resume Builder',
  },
  {
    to: '/linkedin-studio',
    title: 'LinkedIn Profile Enhancement',
    description:
      'Paste or enter your LinkedIn profile, then get scored feedback on headline, About, experience, education, and skills with concrete rewrite suggestions.',
    icon: FiUser,
    tone: 'blue',
    cta: 'Open LinkedIn Studio',
  },
];

const AiStudio = () => {
  return (
    <div className="ai-studio-page">
      <header className="ai-studio-header">
        <h1>AI Studio</h1>
        <p className="ai-studio-subtitle">
          Improve how you show up to recruiters — resume and LinkedIn, scored with clear recommendations.
        </p>
      </header>

      <div className="ai-studio-grid">
        {TOOLS.map(({ to, title, description, icon: Icon, tone, cta }) => (
          <Link key={to} to={to} className="ai-studio-card">
            <div className={`ai-studio-card-icon nav-glyph nav-glyph--lg nav-glyph--${tone || 'blue'}`}>
              <Icon aria-hidden />
            </div>
            <h2>{title}</h2>
            <p>{description}</p>
            <span className="ai-studio-card-cta">
              {cta} <FiArrowRight aria-hidden />
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AiStudio;
